export default __webpack_public_path__ + "static/media/pictogramBeaconFeedback128.c44df4ef.svg";